// Thank's IE8 for his funny defineProperty
module.exports = !require('./$.fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.support-desc.js
 **/